// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2x4ky","footer":"ChangeClinic_footer__2zuCj"};